import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.jsx';
import './i18n.jsx';
import { LazyMotion, domAnimation } from 'framer-motion';

createRoot(document.getElementById('root')).render(
    <LazyMotion features={domAnimation}>
      <App />
    </LazyMotion>
);
